// section-prefs.js — visitor-controlled visibility per editorial section.
// Persisted in localStorage; each entry is a section id that the visitor has
// EXPLICITLY DISABLED. Default state = all sections shown.

const KEY = 'weatherfcc:v32826:section-toggles';

export const SECTIONS = [
  { id: 'minutely',   label: 'Rain in the next hour' },
  { id: 'suggestions',label: 'What to wear' },
  { id: 'sparklines', label: 'Hourly sparklines (temp + precip)' },
  { id: 'uv',         label: 'UV index timeline' },
  { id: 'wind',       label: 'Wind detail + rose' },
  { id: 'almanac',    label: 'Almanac + historical' },
  { id: 'pollen',     label: 'Pollen' },
  { id: 'moon',       label: 'Moon phases' },
  { id: 'radar',      label: 'Radar' },
  { id: 'poi',        label: 'Nearby places' },
  { id: 'fieldnotes', label: 'Field notes' },
  { id: 'quote',      label: 'Quote of the day' },
];

const subs = new Set();
let DISABLED = readDisabled();

function readDisabled() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch (_) { return new Set(); }
}
function writeDisabled() {
  try { localStorage.setItem(KEY, JSON.stringify([...DISABLED])); } catch (_) {}
}

export function isSectionEnabled(id) { return !DISABLED.has(id); }
export function setSectionEnabled(id, enabled) {
  if (enabled) DISABLED.delete(id); else DISABLED.add(id);
  writeDisabled();
  subs.forEach((fn) => { try { fn(); } catch (_) {} });
}
export function getDisabledSet() { return new Set(DISABLED); }
export function subscribeSections(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
